<template>
<div>
    <v-toolbar flat color="white">
        <v-btn small outline style="border-radius: 5px" @click="addTemplate()">
            <v-icon class="mr-1">add</v-icon> New Template
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" label="Search" clearable></v-text-field>
    </v-toolbar>
    <v-data-table :items="templates" :headers="headers" :search="search" style="cursor: pointer">
        <template v-slot:items="props">
            <td class="justify-center layout px-0">
                <v-icon @click="deleteItem(props.item.id)">delete</v-icon>
            </td>
            <td class="text-xs-center" @click="editTemplate(props.item)">{{ props.item.name }}</td>
            <td class="text-xs-center" @click="editTemplate(props.item)">{{ props.item.description }}</td>

        </template>
    </v-data-table>

    <v-dialog v-model="addTemplateModal" persistent width="1000px">
        <v-card flat color="white">
            <v-toolbar flat color="white">
                <v-toolbar-title>{{item.type}} Template</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="!item.id" @click="createTemplate()" outline color="black" flat>Save</v-btn>
                <v-btn v-else @click="updateTemplate()" outline color="black" flat>Save</v-btn>

                <v-btn @click="addTemplateModal=false, item={}" flat>X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout wrap justify-start>
                    <v-flex xs6>
                        <v-text-field v-model="item.name" box label="Title"></v-text-field>
                        <v-textarea height="425" auto-grow box label="Description" v-model="item.description"></v-textarea>
                    </v-flex>
                    <v-flex xs6>
                        <v-list dense :key="formKey">
                            <v-list-tile>
                                <v-list-tile-action>
                                    <v-icon>person</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size:14px">
                                        Assignee
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action style="width: 200px">
                                    <v-autocomplete style="font-size:14px" ref="users" color="black" clearable v-on:blur="$refs['users'].blur()" :items="users" item-text="fullname" item-value="id" v-model="item.assignedToId"></v-autocomplete>
                                </v-list-tile-action>
                            </v-list-tile>
                              <v-list-tile>
                                <v-list-tile-action>
                                    <v-icon>person</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size:14px">
                                        Assigned User Role
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action style="width: 200px">
                                    <v-autocomplete style="font-size:14px" ref="userRole" color="black" clearable v-on:blur="$refs['userRole'].blur()" :items="userRoles" item-text="name" item-value="id" v-model="item.userRoleId"></v-autocomplete>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-action>
                                    <v-icon>group</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title style="font-size:14px">
                                        Collaborators
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" @click="collaboratorModal=true" icon small>
                                                <v-icon small>add</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit Collaborators</span>
                                    </v-tooltip>

                                </v-list-tile-action>

                            </v-list-tile>
                            <v-layout justify-start wrap :key="collaboratorKey">
                                <v-flex xs1 v-for="collaborator in item.taskTemplateCollaborators" :key="collaborator.id">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">

                                            <v-avatar v-on="on" size="35px" color="blue" class="title white--text">
                                                <span class="smallText">{{ collaborator.contact.name.charAt(0)
                              }}{{
                                collaborator.contact.surname.charAt(0)
                              }}</span>
                                            </v-avatar>

                                        </template>
                                        <span>{{ collaborator.contact.name
                              }} {{
                                collaborator.contact.surname
                              }}</span>
                                    </v-tooltip>
                                </v-flex>

                            </v-layout>
                            <v-subheader style="background: #f0f0f0">Forms</v-subheader>
                            <v-list-tile v-for="(form, i) in item.taskTemplateForms" :key="i">
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{form.form.name}}
                                    </v-list-tile-title>
                                    <v-list-tile-title>
                                        {{form.form.description}}
                                    </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                    <v-btn icon @click="updateFormAttachment(form)">
                                        <v-icon>clear</v-icon>
                                    </v-btn>
                                </v-list-tile-action>

                            </v-list-tile>
                            <v-layout justify-center>
                                <v-btn small outline @click="addFormModal=true" color="black" flat>
                                    <v-icon class="mr-1">add</v-icon> Add Form
                                </v-btn>
                            </v-layout>
                        </v-list>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="collaboratorModal" persistent width="400px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Collaborators</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="collaboratorModal=false">X</v-btn>
            </v-toolbar>
            <v-card-text v-if="item.taskTemplateCollaborators">
                <v-layout wrap justify-start :key="collaboratorKey" v-if="item.taskTemplateCollaborators">
                    <v-chip close @input="removeCollaborator(collaborator)" v-for="collaborator in item.taskTemplateCollaborators" :key="collaborator.id">{{collaborator.contact.name}} {{collaborator.contact.surname}}</v-chip>
                </v-layout>
                <v-autocomplete ref="collaborator" dense clearable v-on:blur="$refs['collaborator'].blur()" :items="users.filter(x=>!item.taskTemplateCollaborators.map(y=>y.contactId).includes(x.id))" item-text="fullname" item-value="id" return-object @change="addCollaborator()" v-model="selectedCollaborator"></v-autocomplete>

            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="addFormModal" persistent width="1000px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>Linked Forms</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat outline @click="saveForms()">Save</v-btn>

                <v-btn flat @click="addFormModal = false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-data-table :items="forms" :headers="formHeaders" select-all item-key="id" v-model="taskTemplateForms">
                    <template v-slot:items="props">
                        <td>
                            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td class="text-xs-center" @click="openForm(props.item.id)">{{ props.item.name }}</td>
                        <td class="text-xs-center" @click="openForm(props.item.id)">{{ props.item.description }}</td>

                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "@/services/Api.js";
import dateformat from "dateformat";
export default {
    data: () => ({
        addFormModal: false,
        addTemplateModal: false,
        collaboratorModal: false,
        collaboratorKey: 0,
        item: {},
        forms: [],
        formKey: 0,
        formHeaders: [{
                text: "Name",
                align: "center",
                value: "name",
            },
            {
                text: "Description",
                align: "center",
                value: "description",
            },
        ],
        headers: [{
                text: "Action",
                align: "center",
                sortable: false
            },
            {
                text: "Name",
                align: "center",
                value: "name",
            },
            {
                text: "Description",
                align: "center",
                value: "description",
            },
        ],
        search: '',
        selectedCollaborator: null,
        taskTemplateForms: [],
        templates: [],
        users: [],
        userRoles: []
    }),
    created() {
        this.getTaskTemplates()
        this.getForms()
        this.fetchOrgContacts()
        this.fetchUserRoles()
    },
    methods: {
        async addCollaborator() {
            if (this.item.id) {
                let collaborator = await this.createCollaborator({
                    taskTemplateId: this.item.id,
                    contactId: this.selectedCollaborator.id
                })
                this.item.taskTemplateCollaborators.push(collaborator)
                this.selectedCollaborator = null
            } else {
                this.item.taskTemplateCollaborators.push({
                    contactId: this.selectedCollaborator.id,
                    contact: this.selectedCollaborator
                })
                this.selectedCollaborator = null
            }
            this.collaboratorKey++
        },
        addTemplate() {
            this.item = {
                type: 'Add',
                taskTemplateCollaborators: [],
                taskTemplateForms: []
            }
            this.addTemplateModal = true
        },
        async attachForms(forms) {
            await Api().post('/taskTemplateForms', forms).then(res => {
                this.item.taskTemplateForms = [...this.item.taskTemplateForms, ...res.data]
                this.formKey++
            })
        },
        editTemplate(item) {
            this.item = item
            this.item.type = 'Edit'
            this.taskTemplateForms = this.item.taskTemplateForms.map(x => x.form)
            this.addTemplateModal = true
        },
        async createTemplate() {
            await Api().post('/taskTemplate', this.item).then(res => {
                this.getTaskTemplates()
                this.addTemplateModal = false
                this.item = {}
            })
        },
        async updateTemplate() {
            await Api().put('/taskTemplate/'+this.item.id, this.item).then(res => {
                this.getTaskTemplates()
                this.addTemplateModal = false
                this.item = {}
            })
        },
        async createCollaborator(obj) {
            let result = {}
            await Api().post('/taskTemplate/subscribe/' + obj.taskId, obj).then(res => {
                result = res.data
            })
            return result
        },
        fetchOrgContacts() {
            Api()
                .get("/organisationContact")
                .then(async (response) => {
                    this.users = response.data.map((x) => x.contact).map(x => ({
                        id: x.id,
                        fullname: x.name + ' ' + x.surname,
                        name: x.name,
                        surname: x.surname,
                        email: x.email,
                        mobileNumber: x.mobileNumber
                    }))
                });

        },
        fetchUserRoles() {
            Api()
                .get('/userRole')
                .then(response => {
                    this.userRoles = response.data
                })
        },
        getTaskTemplates() {
            Api().get('/taskTemplate').then(res => {
                this.templates = res.data
            })
        },
        getForms() {
            Api().get('/forms').then(res => {
                this.forms = res.data
            })
        },
        removeCollaborator(collaborator) {
            if (this.item.id) {
                let index = this.item.taskTemplateCollaborators.indexOf(collaborator)
                this.item.taskTemplateCollaborators.splice(index, 1)
                Api().put('/taskTemplate/unsubscribe/' + collaborator.id, {
                    isActive: false,
                    isDeleted: true
                })
            } else {
                let index = this.item.taskTemplateCollaborators.indexOf(collaborator)
                this.item.taskTemplateCollaborators.splice(index, 1)
            }
            this.collaboratorKey++
        },
        async saveForms() {
            let existingForms = this.item.taskTemplateForms.map(x => x.formId)
            let newForms = this.taskTemplateForms.filter(x => !existingForms.includes(x.id)).map(x => ({
                formId: x.id,
                form: x,
                taskTemplateId: this.item.id
            }))
            if (newForms.length > 0)
                await this.attachForms(newForms)
            this.addFormModal = false
        },
        updateFormAttachment(item) {
            if (item.id) {
                Api().put('/taskTemplateForms/' + item.id, {
                    isActive: false,
                    isDeleted: true
                }).then(res => {
                    let index = this.item.taskTemplateForms.indexOf(item)
                    this.item.taskTemplateForms.splice(index, 1)
                    this.taskTemplateForms = this.item.taskTemplateForms.map(x => x.form)
                })
            } else {
                let index = this.item.taskTemplateForms.indexOf(item)
                this.item.taskTemplateForms.splice(index, 1)
                this.taskTemplateForms = this.item.taskTemplateForms.map(x => x.form)
            }
        }
    }
}
</script>
